import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// get Services List
export const getServicesList = createAsyncThunk(
  "getServicesList",
  async (company_id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `service-requests?company_id=${company_id}`
      );
      return response.data.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get On Going Service Requests
export const getOnGoingServiceRequests = createAsyncThunk(
  "getOnGoingServiceRequests",
  async ({ status, company_id, pageCount, pageLimit }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `service-requests?status=${status}&company_id=${company_id}&page=${pageCount}&limit=${pageLimit}`
      );
      return response.data.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Services Request
export const createServicesRequest = createAsyncThunk(
  "createServicesRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`service-requests`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Get service requests users List
export const serviceRequestsUsers = createAsyncThunk(
  "serviceRequestsUsers",
  async ({ type, company_id }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `service-requests-users?type=${type}&company_id=${company_id}`
      );
      return response.data.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Update Service
export const updateService = createAsyncThunk(
  "updateService",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`service-requests/${id}`, data);
      toast.success(response.data.msg);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const serviceRequestSlice = createSlice({
  name: "serviceRequest",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // get Master Setting By slug
      .addCase(getServicesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServicesList.fulfilled, (state, action) => {
        state.loading = false;
        state.getServicesListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServicesList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Master Setting By slug
      .addCase(createServicesRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(createServicesRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.createServicesRequestStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createServicesRequest.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get service requests users List
      .addCase(serviceRequestsUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(serviceRequestsUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.serviceRequestsUsersStatus.data = action.payload;
        state.error = false;
      })
      .addCase(serviceRequestsUsers.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get On Going Service Requests
      .addCase(getOnGoingServiceRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOnGoingServiceRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.getOnGoingServiceRequestsStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getOnGoingServiceRequests.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Update Service
      .addCase(updateService.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateService.fulfilled, (state, action) => {
        state.loading = false;
        state.updateServiceStatus.data = action.payload;
        state.error = false;
      })
      .addCase(updateService.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = serviceRequestSlice;
export default reducer;
